import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import useOverlay from "../../hooks/useOverlay";
import { CART_PATH, HOME_PATH, SEARCH_PATH } from "../../routes";
import { asset } from "../../utils/format";
import DepartmentFilter from "../filters/DepartmentFilter";

const ANNOUNCEMENTS = [
  "Free home delivery in the Lower Mainland and Fraser Valley on all orders over $250",
  "Pickup available at Eastern Hillside, Chilliwack, BC.",
  "Country/region: Canada | CAD $",
];

export default function Header() {
  const announcementRef = useRef(null);
  useLayoutEffect(() => {
    const bar = announcementRef.current;
    const measure = () => {
      document.documentElement.style.setProperty("--announcement-height", `${bar?.getBoundingClientRect().height || 44}px`);
      document.documentElement.style.setProperty("--store-header-height", `${bar?.parentElement?.getBoundingClientRect().height || 180}px`);
    };
    measure();
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    if (bar) { observer?.observe(bar); observer?.observe(bar.parentElement); }
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", measure);
      document.documentElement.style.removeProperty("--announcement-height");
      document.documentElement.style.removeProperty("--store-header-height");
    };
  }, []);
  const [announcement, setAnnouncement] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setAnnouncement((current) => (current + 1) % ANNOUNCEMENTS.length), 5000);
    return () => clearInterval(timer);
  }, []);
  const { count } = useCart();
  const { open } = useOverlay();

  return (
    <header className="top">
      <div ref={announcementRef} className="shippingAnnouncement" aria-label="Store announcements">
        <span key={announcement} className={`announcementText${announcement !== 2 ? " announcementLong" : ""}`}>{ANNOUNCEMENTS[announcement]}</span>
      </div>
      <div className="wrap shopPanel">
        <div className="panelTop">
          <Link to={HOME_PATH} style={{ display: "contents", color: "inherit", textDecoration: "none" }}>
            <img className="brandLogo" src={asset("images/mr_marketplace_logo.png")} alt="Marketplace" />
            <div className="panelIntro">
              <h1>MARKETPLACE</h1>
            </div>
          </Link>
          <div className="panelActions">
            <button type="button" id="v131SearchToggle" aria-label="Search products" onClick={() => open(SEARCH_PATH)}>
              <svg viewBox="0 0 48 48" aria-hidden="true">
                <circle cx="21" cy="21" r="13" fill="none" stroke="currentColor" strokeWidth="3.2" />
                <path d="M31 31l10 10" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" />
              </svg>
            </button>
            <button type="button" className="cartbtn" id="openCart" aria-label="Open bag" onClick={() => open(CART_PATH)}>
              <svg className="v130CartIcon" viewBox="0 0 48 48" aria-hidden="true">
                <path d="M7 9h5l3.2 21.2h22.1l3.4-15.3H14" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="19" cy="38" r="2.8" fill="currentColor" />
                <circle cx="35" cy="38" r="2.8" fill="currentColor" />
              </svg>
              <span id="count" className="v130CartCount">
                {count}
              </span>
            </button>
          </div>
        </div>
        <div className="sectionLabel">Department</div>
        <DepartmentFilter />
      </div>
    </header>
  );
}
